import React, {useState} from 'react';
import TreeChartView from "./TreeChartView";
import AddTafsiliModal from "./AddTafsiliModal";
import numericFunction from "../../../../utils/NumericFunction";


const SvgFillMinusIcon = (props) => <>
  <svg onClick={props.onClick} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"
       fill="none">
    <path
      d="M15.2424 18.9582H4.75911C1.92577 18.9582 1.77577 17.3998 1.65077 16.1415L1.31744 11.9665C1.24244 11.1582 1.47577 10.3498 1.99244 9.69984C2.60911 8.94984 3.48411 8.5415 4.42577 8.5415H15.5757C16.5007 8.5415 17.3757 8.94984 17.9674 9.65817L18.1091 9.84984C18.5591 10.4665 18.7591 11.2165 18.6841 11.9748L18.3507 16.1332C18.2257 17.3998 18.0757 18.9582 15.2424 18.9582ZM4.42577 9.7915C3.86744 9.7915 3.33411 10.0415 2.98411 10.4748L2.92577 10.5332C2.65911 10.8748 2.51744 11.3582 2.56744 11.8582L2.90077 16.0332C3.01744 17.2498 3.06744 17.7082 4.75911 17.7082H15.2424C16.9424 17.7082 16.9841 17.2498 17.1007 16.0248L17.4341 11.8498C17.4841 11.3582 17.3424 10.8665 17.0174 10.4832L16.9341 10.3832C16.5591 9.9915 16.0841 9.7915 15.5674 9.7915H4.42577Z"
      fill="#808487"/>
    <path
      d="M17.0834 10.1835C16.7417 10.1835 16.4584 9.9002 16.4584 9.55854V8.06689C16.4584 5.58356 16.025 5.15023 13.5417 5.15023H11.4167C10.475 5.15023 10.15 4.81689 9.79169 4.34189L8.71669 2.91689C8.35002 2.43356 8.26669 2.31689 7.51669 2.31689H6.45835C3.97502 2.31689 3.54169 2.75023 3.54169 5.23356V9.5252C3.54169 9.86687 3.25835 10.1502 2.91669 10.1502C2.57502 10.1502 2.29169 9.86687 2.29169 9.5252V5.23356C2.29169 2.04189 3.26669 1.06689 6.45835 1.06689H7.52502C8.80835 1.06689 9.20835 1.48356 9.72502 2.16689L10.7917 3.58356C11.0167 3.88356 11.0334 3.90023 11.425 3.90023H13.55C16.7417 3.90023 17.7167 4.87523 17.7167 8.06689V9.55854C17.7084 9.9002 17.425 10.1835 17.0834 10.1835Z"
      fill="#808487"/>
    <path
      d="M12.1414 14.7915H7.85809C7.51643 14.7915 7.23309 14.5082 7.23309 14.1665C7.23309 13.8248 7.51643 13.5415 7.85809 13.5415H12.1414C12.4831 13.5415 12.7664 13.8248 12.7664 14.1665C12.7664 14.5082 12.4914 14.7915 12.1414 14.7915Z"
      fill="#808487"/>
  </svg>
</>

const SvgFillPluseIcon = (props) => <>
  <svg onClick={props.onClick} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"
       fill="none">
    <path
      d="M10.0504 14.3752C9.70875 14.3752 9.42542 14.0918 9.42542 13.7502V9.5835C9.42542 9.24183 9.70875 8.9585 10.0504 8.9585C10.3921 8.9585 10.6754 9.24183 10.6754 9.5835V13.7502C10.6754 14.0918 10.3921 14.3752 10.0504 14.3752Z"
      fill="#808487"/>
    <path
      d="M12.0834 12.2915H7.91669C7.57502 12.2915 7.29169 12.0082 7.29169 11.6665C7.29169 11.3248 7.57502 11.0415 7.91669 11.0415H12.0834C12.425 11.0415 12.7084 11.3248 12.7084 11.6665C12.7084 12.0082 12.425 12.2915 12.0834 12.2915Z"
      fill="#808487"/>
    <path
      d="M14.1667 18.9582H5.83335C2.15835 18.9582 1.04169 17.8415 1.04169 14.1665V5.83317C1.04169 2.15817 2.15835 1.0415 5.83335 1.0415H7.08335C8.54169 1.0415 9.00002 1.5165 9.58335 2.2915L10.8334 3.95817C11.1084 4.32484 11.15 4.37484 11.6667 4.37484H14.1667C17.8417 4.37484 18.9584 5.4915 18.9584 9.1665V14.1665C18.9584 17.8415 17.8417 18.9582 14.1667 18.9582ZM5.83335 2.2915C2.85835 2.2915 2.29169 2.85817 2.29169 5.83317V14.1665C2.29169 17.1415 2.85835 17.7082 5.83335 17.7082H14.1667C17.1417 17.7082 17.7084 17.1415 17.7084 14.1665V9.1665C17.7084 6.1915 17.1417 5.62484 14.1667 5.62484H11.6667C10.6 5.62484 10.25 5.25817 9.83335 4.70817L8.58335 3.0415C8.15002 2.4665 8.02502 2.2915 7.08335 2.2915H5.83335Z"
      fill="#808487"/>
  </svg>
</>

const SvgFillNoneIcon = (props) => <>
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M14.1667 18.9582H5.83335C2.15835 18.9582 1.04169 17.8415 1.04169 14.1665V5.83317C1.04169 2.15817 2.15835 1.0415 5.83335 1.0415H7.08335C8.54169 1.0415 9.00002 1.5165 9.58335 2.2915L10.8334 3.95817C11.1084 4.32484 11.15 4.37484 11.6667 4.37484H14.1667C17.8417 4.37484 18.9584 5.4915 18.9584 9.1665V14.1665C18.9584 17.8415 17.8417 18.9582 14.1667 18.9582ZM5.83335 2.2915C2.85835 2.2915 2.29169 2.85817 2.29169 5.83317V14.1665C2.29169 17.1415 2.85835 17.7082 5.83335 17.7082H14.1667C17.1417 17.7082 17.7084 17.1415 17.7084 14.1665V9.1665C17.7084 6.1915 17.1417 5.62484 14.1667 5.62484H11.6667C10.6 5.62484 10.25 5.25817 9.83335 4.70817L8.58335 3.0415C8.15002 2.4665 8.02502 2.2915 7.08335 2.2915H5.83335Z"
      fill="#808487"/>
  </svg>
</>

const MoinIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path
    d="M13.3333 10.625H6.66666C6.32499 10.625 6.04166 10.3417 6.04166 10C6.04166 9.65833 6.32499 9.375 6.66666 9.375H13.3333C13.675 9.375 13.9583 9.65833 13.9583 10C13.9583 10.3417 13.675 10.625 13.3333 10.625Z"
    fill="#7C8CC3"/>
  <path
    d="M10 13.9582C9.65833 13.9582 9.375 13.6748 9.375 13.3332V6.6665C9.375 6.32484 9.65833 6.0415 10 6.0415C10.3417 6.0415 10.625 6.32484 10.625 6.6665V13.3332C10.625 13.6748 10.3417 13.9582 10 13.9582Z"
    fill="#7C8CC3"/>
  <path
    d="M12.5 18.9582H7.49999C2.97499 18.9582 1.04166 17.0248 1.04166 12.4998V7.49984C1.04166 2.97484 2.97499 1.0415 7.49999 1.0415H12.5C17.025 1.0415 18.9583 2.97484 18.9583 7.49984V12.4998C18.9583 17.0248 17.025 18.9582 12.5 18.9582ZM7.49999 2.2915C3.65832 2.2915 2.29166 3.65817 2.29166 7.49984V12.4998C2.29166 16.3415 3.65832 17.7082 7.49999 17.7082H12.5C16.3417 17.7082 17.7083 16.3415 17.7083 12.4998V7.49984C17.7083 3.65817 16.3417 2.2915 12.5 2.2915H7.49999Z"
    fill="#7C8CC3"/>
</svg>
const SubsidiaryIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"
                                  fill="none">
  <path
    d="M12.5 18.9582H7.49999C2.97499 18.9582 1.04166 17.0248 1.04166 12.4998V7.49984C1.04166 2.97484 2.97499 1.0415 7.49999 1.0415H9.16666C9.50832 1.0415 9.79166 1.32484 9.79166 1.6665C9.79166 2.00817 9.50832 2.2915 9.16666 2.2915H7.49999C3.65832 2.2915 2.29166 3.65817 2.29166 7.49984V12.4998C2.29166 16.3415 3.65832 17.7082 7.49999 17.7082H12.5C16.3417 17.7082 17.7083 16.3415 17.7083 12.4998V10.8332C17.7083 10.4915 17.9917 10.2082 18.3333 10.2082C18.675 10.2082 18.9583 10.4915 18.9583 10.8332V12.4998C18.9583 17.0248 17.025 18.9582 12.5 18.9582Z"
    fill="#7C8CC3"/>
  <path
    d="M7.08278 14.742C6.57445 14.742 6.10778 14.5587 5.76611 14.2253C5.35778 13.817 5.18278 13.2253 5.27445 12.6003L5.63278 10.092C5.69945 9.60866 6.01611 8.98366 6.35778 8.64199L12.9244 2.07529C14.5827 0.416959 16.2661 0.416959 17.9244 2.07529C18.8327 2.98363 19.2411 3.90863 19.1577 4.83363C19.0827 5.58363 18.6827 6.31696 17.9244 7.06696L11.3577 13.6337C11.0161 13.9753 10.3911 14.292 9.90774 14.3587L7.39945 14.717C7.29111 14.742 7.18278 14.742 7.08278 14.742ZM13.8077 2.95863L7.24111 9.52533C7.08278 9.68366 6.89945 10.0503 6.86611 10.267L6.50778 12.7753C6.47445 13.017 6.52445 13.217 6.64945 13.342C6.77445 13.467 6.97445 13.517 7.21611 13.4837L9.7244 13.1253C9.94107 13.092 10.3161 12.9087 10.4661 12.7503L17.0327 6.18363C17.5744 5.64196 17.8577 5.15863 17.8994 4.70863C17.9494 4.16696 17.6661 3.59196 17.0327 2.95029C15.6994 1.61696 14.7827 1.99196 13.8077 2.95863Z"
    fill="#7C8CC3"/>
  <path
    d="M16.5413 8.19124C16.483 8.19124 16.4247 8.18291 16.3747 8.16624C14.183 7.54957 12.4413 5.80791 11.8247 3.61624C11.733 3.28291 11.9247 2.94124 12.258 2.84124C12.5913 2.74957 12.933 2.94124 13.0247 3.27457C13.5247 5.04957 14.933 6.45791 16.708 6.95791C17.0413 7.04957 17.233 7.39957 17.1413 7.73291C17.0663 8.01624 16.8163 8.19124 16.5413 8.19124Z"
    fill="#7C8CC3"/>
</svg>
const SvgDocument = (props) => <>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-file-text"
       viewBox="0 0 16 16" onClick={props.onClick}>
    <path
      d="M5 4a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1H5zm-.5 2.5A.5.5 0 0 1 5 6h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zM5 8a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1H5zm0 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1H5z"/>
    <path
      d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm10-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1z"/>
  </svg>
</>

const SingleChart = (props) => {

  const {treeChartData} = props;
  const [openMenu, setOpenMenu] = useState(localStorage.getItem("treeChartOpenCloseData") !== null ?
    JSON.parse(localStorage.getItem("treeChartOpenCloseData"))[treeChartData.code]
    :
    false
  )
  const [openModalAddTAFSILI, setOpenModalAddTAFSILI] = useState({
    isOpen: false
  })

  function saveToLocalStorage(key, value) {
    const treeChartOpenCloseData = localStorage.getItem("treeChartOpenCloseData");
    let temp = treeChartOpenCloseData !== null ? JSON.parse(treeChartOpenCloseData) : {};
    temp[key] = value;
    localStorage.setItem("treeChartOpenCloseData", JSON.stringify(temp))

  }

  const openMenuAndSave = (inputData) => {
    // //debugger
    saveToLocalStorage(inputData.code, !openMenu)
    setOpenMenu(!openMenu);
  }

  return (
    <>
      {openModalAddTAFSILI.isOpen && <>
        <AddTafsiliModal
          isOpen={openModalAddTAFSILI}
          modalCallback={setOpenModalAddTAFSILI}
          treeChartData={treeChartData}
          setReload={props.setReload}

        /></>}
      <div style={{
        padding: '5px 0 ',
        margin: '5px 0',
        // borderRight: '1px solid #aaa',
        // borderBottom: '1px solid #aaa',
        // border:'0 1px 1px 0 solid #ff0000',
        borderRadius: 10
      }}>
        <div style={{fontSize: '12px', color: '#484848'}}>
          {(!treeChartData.editSubsidiary) ?
            <span className={"px-1 cursor__pointer"}>
                  {treeChartData.editSubsidiay && treeChartData.entityRecord ? <><SvgDocument
                      onClick={() => {
                        props.onClickJoinTitle(treeChartData.title)
                        props.requestDataToShowDocumentDetails(treeChartData)
                      }}/> </> :
                    <>{openMenu ?
                      <SvgFillMinusIcon
                        title={(treeChartData.subAccounts !== undefined && treeChartData.subAccounts.length !== 0) ? "زیر منو دارد" : "زیرمنو ندارد"}
                        onClick={() => openMenuAndSave({...treeChartData})}/> :
                      <SvgFillPluseIcon
                        title={(treeChartData.subAccounts !== undefined && treeChartData.subAccounts.length !== 0) ? "زیر منو دارد" : "زیرمنو ندارد"}
                        onClick={() => openMenuAndSave({...treeChartData})}/>
                    }
                    </>}
                </span> : SvgFillNoneIcon()}
          {<span className={"cursor__pointer px-1"}
                 onClick={() => {
                   props.onClickJoinTitle(treeChartData.title)
                   // props.requestDataToShowDocumentDetails(treeChartData)
                 }}
          >
                  {/*{console.log(treeChartData)}*/}
            {numericFunction.e2p(treeChartData.title)}<small>{treeChartData.entityRecord ? " ( " + treeChartData.code + " ) " : " "}</small>
                </span>}
          {treeChartData.defineSubsidiary === true &&
            <span title={'افزودن معین'}
                  className={'cursor__pointer'}
                  onClick={() => {
                    props.onClickJoinTitle(treeChartData.title)
                    props.requestDataToShowMoein(treeChartData)
                  }}>
              <MoinIcon/>
            </span>}

          {treeChartData.editSubsidiary === true &&
            <span title={'ویرایش معین'}
                  className={'cursor__pointer'}
                  onClick={() => {
                    props.onClickJoinTitle(treeChartData.title)
                    props.requestDataToEditeMoein(treeChartData)
                  }}>
              <SubsidiaryIcon/>

            </span>}
        </div>

        {openMenu ?
          <>
            <div style={{paddingRight: 15}}>
              {treeChartData.subAccounts !== undefined && treeChartData.subAccounts.length > 0 && <>
                <TreeChartView
                  treeChartData={treeChartData.subAccounts}
                  requestDataToShowDocumentDetails={props.requestDataToShowDocumentDetails}
                  requestDataToShowMoein={props.requestDataToShowMoein}
                  requestDataToEditeMoein={props.requestDataToEditeMoein}
                  onClickJoinTitle={props.onClickJoinTitle}
                  setReload={props.setReload}
                />
              </>}
            </div>
          </> :
          <></>
        }
      </div>

    </>
  );
};


export default SingleChart;
